module.exports = __webpack_public_path__ + "static/media/d3.e9ebbc47.png";